import React, { useEffect, useRef, useState} from 'react';
import * as d3s from 'd3-selection';
import * as d3z from 'd3-zoom';
import * as d3h from 'd3-hierarchy';
import * as d3sh from 'd3-shape';
import * as d3 from 'd3';
import * as d3sc from 'd3-scale';
import  './Graph.css';

const RadialGraph = ({room,  mmNodes, graphRatio, graphWidth, graphHeight, scrollMessages, request_a_form, request_a_correction,
                      disp_dom_messages, nb_messages, domain_matches, graphDepth, isMobile, 
                       hideTooltipWhenOut}) => {
  const svgRef = useRef();

  const tooltipHovered = useRef(false);
  const tooltip = useRef(null)
  const currentNode = useRef(null)
  const tooltip_header = useRef(null)
  const tooltip_info = useRef(null)
  const tooltip_refs = useRef(null)
  const displaying_tooltip = useRef(false)
  const hideTimeout = useRef(null);
  const showTimeout = useRef(null);
  const tooltipWindowWidth = window.parent.innerWidth;
  const tooltipWindowHeight = window.parent.innerHeight;

  const [_refresh, do_refresh] = useState(0)

  const [centerNodeId, setCenterNodeId] = useState('');
  const [svgClass, setSvgClass] = useState(null);
  const [transformValue, setTransform] = useState('');
  const [revTransformValue, setRevTransform] = useState('');
  const m_Nodes = useRef(mmNodes)
  const [fullScreen, setFullScreen] = useState(false)
  const r_disp_dom_messages = useRef(disp_dom_messages)
  const [nb_bubbles, setNbBubbles] = useState(0)
  let max_depth = 3
  const match_window_size = 100
  const fullScreenRatio = 2.7
  const bubbles_opacity = 0.2

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  const tooltip_width_threshold = 0.8
  const tooltip_margin = windowWidth * 0.03 ; // espace entre le curseur et le tooltip
  const tooltip_vmargin = windowHeight * 0.02 ; // espace entre le curseur et le tooltip
  const thresholdForMessages = 2.7
  const offset_angle = - Math.PI / 4

  function removeAfterLastUnderscore(str) {
    const lastIndex = str.lastIndexOf('_');
    return lastIndex !== -1 ? str.substring(0, lastIndex) : str;
  }


  const find_source_displayed_texts = ((svg, id) => {
  let res = null
  if (svg === null) return res
  const disp_nodes = svg.select("g[id='graphDomMessagesTexts']").selectAll("text")
  // const disp_nodes = displayed_nodes
  if (disp_nodes === undefined)
    return null
  try {
  disp_nodes.nodes().forEach(function(nd, i){
    const data = nd.__data__
    if (removeAfterLastUnderscore(data.id) === removeAfterLastUnderscore(id)) {
      res = data
    }
  })
 } catch {}
  return res
 })

  const find_source_displayed_nodes = ((svg, id) => {
  let res = null
  if (svg === null) return res
  const disp_nodes = svg.select("g[id='graphNodes']").selectAll("circle")
  // const disp_nodes = displayed_nodes
  if (disp_nodes === undefined)
    return null
  try {
  disp_nodes.nodes().forEach(function(nd, i){
    const data = nd.__data__
    if (removeAfterLastUnderscore(data.data.id) === removeAfterLastUnderscore(id)) {
      res = data
    }
  })
 } catch {}
  return res
 })


// Function to build hierarchy
function buildHierarchy(nodeList, gdepth) {
  // Create a map of nodes by their ID
  if (nodeList.length === 0) {
    return []
  }

  const fnode = nodeList[0]
  if (fnode.id === undefined){
    fnode.id = fnode.name
  }
  const nodeMap = new Map();
  nodeList.forEach(node => {
    nodeMap.set(node.id, { ...node, children: [] });
  });

  let root = null
  // Link children to their respective parent nodes
  nodeList.forEach(node => {
    const currentNode = nodeMap.get(node.id);
    if (node.fils){
      node.fils.forEach(childId => {
        const childNode = nodeMap.get(childId);
        if (childNode && (childNode.depth <= gdepth)) {
          currentNode.children.push(childNode);
        }
      });
    } else {
      node.children = []
    }
   // If a node does not have a parent, it might be the root
   if ((root == null) && (node.fils != null) && (node.fils != undefined) && (!nodeList.some(n => n.fils && n.fils.includes(node.id)))) {
    root = currentNode;
  }

  });
  return root;
}

    // Fonction de zoom
const fzoom = d3z.zoom()
      .scaleExtent([0.1, 20]) // Échelle de zoom minimale et maximale
      .extent([[0, 0], [graphWidth, graphHeight]]) // 👈 OBLIGATOIRE pour firefox
      .on('zoom', (event) => {
        // Appliquer la transformation du zoom au groupe
        let zoomTransform = event.transform
        let revZoomTransform = d3z.zoomIdentity.translate(-event.transform.x, -event.transform.y).scale(event.transform.k)
        if (transformValue !== '' ) {
          zoomTransform = d3z.zoomIdentity.translate(event.transform.x, event.transform.y).scale(event.transform.k);
          revZoomTransform = d3z.zoomIdentity.translate(-event.transform.x * event.transform.k, -event.transform.y * event.transform.k);
        }
        setTransform(zoomTransform)
        setRevTransform(revZoomTransform)
      });

function compute_node_radius(d) {
      let scale = 0.3 // d.data.quality
      if (d.source) return
      if (scale === undefined || d.data.depth === 1){
        scale = 0.32
      }
      // scale = scale ** 2
      if (d.data.depth === 0) return 20 * scale
      else if (d.data.depth === 1) return 45 * scale
      else if (d.data.depth === 5) return 20 * scale
      else {
        const res = (40 - (d.data.depth - 2) * 9)
        return res * scale
      }
  }


  function showTooltip() {
    console.log('show tooltip')

    if (currentNode.current === null) return
    const event = currentNode.current.event
    const node = currentNode.current.node
    const d = currentNode.current.d
    if (d === undefined || d === null) return
    if (node == undefined || node == null) return
    tooltip.current.style('pointer-events', 'all')
    if (tooltipHovered.current) {
        tooltip.current.style('opacity', '1')
      return
    }
    if (displaying_tooltip.current) return
    if (d.source) return
    event.stopPropagation()
    node
            .attr('r', 100 * compute_node_radius(d))
            .attr('opacity', d.data.depth === 1 ? 0.15 : 0.02);
        currentNode.current.displaying = true
        const tooltipWidth = tooltip.current.node().offsetWidth * 0.6;
        const tooltipHeight = tooltip.current.node().offsetHeight;

        // Dimensions de la fenêtre (ou du conteneur, voir plus bas)

        // Position candidate
        let tx = event.pageX 
        let ty = event.pageY + tooltip_vmargin     

        delayHideToolTip()

        // Clamp horizontalement
        if (tx + tooltipWidth > tooltipWindowWidth) {
          tx = event.pageX - tooltipWidth - 2 * tooltip_margin
        }

      
        // Clamp verticalement
        if (tooltipHeight + ty > tooltipWindowHeight / 3) {
          ty = event.pageY - tooltipHeight - tooltip_vmargin;
        }
    

       let description = ''
       const desc = d.data.description.split('--- EXEMPLES ---')[0]

       const listAnchors = desc.split('ALTAIEGOREF')
       if (listAnchors.length % 2 === 1) {
        listAnchors.forEach((substring, index) => {
          if (index % 2 == 0) {
            description += " " + substring
          } else {
            description += ' [-> ref' + index + '] '
            const laref = tooltip_refs.current.node().querySelector('#aref' + index);
            if (laref == null) {
              const link = document.createElement("a");
              link.id = "aref" + index
              link.href = substring;
              link.target = "altai_ego_helper";
              link.textContent = "ref" + index + " "
              tooltip_refs.current.node().appendChild(link);
            }
          }
        })
       } else {
        description = desc
       }
       description.split('\n').forEach((substring, index) => {
         const ref =  tooltip_info.current.node()
         if (index === 0){
           ref.replaceChildren();
         }
         if (substring.length > 0) {
          const line = document.createElement("p");
          line.textContent = substring
          ref.appendChild(line)
         }
        
       });
        // Appliquer les positions finales
        if (!tooltipHovered.current) {
          tooltip.current.style('opacity', '0.2')
        } else {
          tooltip.current.style('opacity', '1')
        }
        tooltip_header.current.text(d.data.name)

        tooltip.current
          .style('width', '90%')
          .style('left', `${tx}px`)
          .style('top', `${ty}px`);
          do_refresh( prev => prev % 10 == 0 ? 0 :  prev + 1)
  }


  function hideTooltip() {
        console.log('hide tooltip')
        tooltip.current.style('pointer-events', 'none')
          tooltip_info.current.node().replaceChildren()
          if (tooltip_refs.current && tooltip_refs.current.node()) tooltip_refs.current.node().replaceChildren()
          tooltip.current.style('opacity', 0);
          // tooltip.current.style('width', 0)
          // tooltip.current.style('height', '0%')
          const current = currentNode.current;
          if (current) {
            const { event, node, d } = current;
            if (d == null) return
            if (d.source == null) { // un tooltip de node de l'arbre
              if (((d.data.description === undefined) || (d.data.description === null)) ){
                return
              }
              if ((d.data.quality < 0.2) && (d.data.depth > 5)){
                return
              }
              currentNode.current = null;
              node
              .attr('r', compute_node_radius(d))
              .attr('opacity', d.data.depth === 1 ? 0.85 : 0.15);

            } else if (current['orig-width']) {
                displaying_tooltip.current = false
                node.attr('width', current['orig-width']);
                node.attr('height', current['orig-height']);
                node.attr('opacity',1);
            }

            tooltipHovered.current = false
          }
          currentNode.current = null
          do_refresh( prev => prev % 10 == 0 ? 0 :  prev + 1)

  }
  
  function cancelShowTooltip() {
    console.log('cancel show tooltip')
    if (showTimeout.current !== null) {
      clearTimeout(showTimeout.current);
      showTimeout.current = null;
    }
  }
  
  function cancelHideTooltip() {
    // console.log('cancel hide tooltip')
    if (hideTimeout.current !== null) {
      clearTimeout(hideTimeout.current);
      hideTimeout.current = null;
    }
  }
  const tooltip_delay = 500

  function delayShowToolTip(delay=tooltip_delay) {
    // console.log('delay show tooltip')
    if (showTimeout.current != null) return
    showTimeout.current = setTimeout(() => {
        cancelShowTooltip()
        showTooltip();
    }, delay);

  }

  function delayHideToolTip() {
    console.log('delay hide tooltip')

    if (hideTimeout.current != null) return
    if (tooltipHovered.current) {
      return;
    }

    hideTimeout.current = setTimeout(() => {
      if (!tooltipHovered.current && hideTimeout.current) {
        hideTooltip();
      }
      hideTimeout.current = null;
    }, 3 * tooltip_delay);
  }


useEffect(() => {
  const svg = d3s.select(svgRef.current)
    .attr('viewBox', '0 0 101% 101%') // default width and height for chrome to adapt automatically
    .attr('class', 'svg_viewbox')
    .attr('preserveAspectRatio', 'xMidYMid meet'); // Assure le maintient du ratio d'aspect
  
  tooltip.current = d3.select('.tooltip')
  tooltip.current.style('pointer-events', 'none')

  tooltip_header.current = tooltip.current.select('.tooltip_header')
  tooltip_info.current = tooltip.current.select('.tooltip_info')
  tooltip_refs.current = tooltip.current.select('.tooltip_refs')

  tooltip.current.node().addEventListener("mouseenter", (event) => {
      if (!displaying_tooltip.current) event.stopPropagation()
      currentNode.current = {
          event : event,
          node : currentNode.current ? currentNode.current.node : null,
          d: currentNode.current ? currentNode.current.d : null
       };
      tooltipHovered.current = true
      delayShowToolTip()
      cancelHideTooltip()
      console.log('tooltip_info over')

    });


  tooltip.current.node().addEventListener("mousemove", (event, d) => {
      event.stopPropagation()
      tooltipHovered.current = true
      cancelShowTooltip()
      cancelHideTooltip()
      showTooltip()
      console.log('tooltip_info move')
  })

  tooltip.current.node().addEventListener("mouseleave", (event, d) => {
      event.stopPropagation()
      tooltipHovered.current = false
      showTooltip()
      delayHideToolTip()
      console.log('tooltip_info out')
    });


  setTimeout(() => {
           svg.call(fzoom);
         }, 0)
    // Appliquer le comportement de zoom à l'élément SVG
  const initialTransform = d3z.zoomIdentity.translate(250, 180).scale(1);

  if (svgClass != null) {
      svg.attr('class', svgClass)
  }
 setTimeout(() => {
      svg.call(fzoom.transform, initialTransform);
 }, 0)

   // graphPos.attr('transform', d3z.zoomIdentity.translate(100, 100))
}, [])


useEffect(() => {
  const svg = d3s.select(svgRef.current)
  const graph = svg.select("#graph")
  if (transformValue === '') {
    return
  }
  const ratioTransform = d3z.zoomIdentity.translate(transformValue.x, transformValue.y).scale(transformValue.k);
    // graph.attr('transform', ratioTransform);
    // console.log('reapply transfo')
    setTransform(ratioTransform)
   // graphPos.attr('transform', d3z.zoomIdentity.translate(100, 100))
   hideTooltipWhenOut()
}, [graphRatio])

useEffect(() =>{ 
  
  // since size of the diagram changes on depth change, better to start from null
const svg = d3s.select(svgRef.current)

          svg.select("g[id='graphNodes']").selectAll("circle")
          .data([]).exit().remove();
      
          svg.select("g[id='graphLinks']").selectAll("path")
            .data([]).exit().remove();
      
          svg.select("g[id='graphLabels']").selectAll("text")
            .data([]).exit().remove();
       
          svg.select("g[id='graphDomNickLabels']").selectAll("text")
                .data([]).exit().remove();
      
          svg.select("g[id='graphDomMessagesBgs']").selectAll("rect")
                .data([]).exit().remove();
      
          svg.select("g[id='graphDomMessagesTexts']").selectAll("text")
                .data([]).exit().remove()

          svg.select("g[id='graphDomMessagesRoute']").selectAll("g")
                .data([]).exit().remove();
          svg.select("g[id='graphDomMessagesRoute']").selectAll("circle")
                .data([]).exit().remove();
          svg.select("g[id='graphDomMessagesRoute']").selectAll("path")
                .data([]).exit().remove();
               

}, [graphDepth, graphRatio, room])

useEffect (() => {
    const graph = d3.select("#graph")
    // graphPositioner.attr("transform", `translate(${graphWidth / 2},${graphHeight / 2})`)
    graph.attr("transform", transformValue)
    //const graphRoutes = d3.select("#graphDomMessagesRoute")
    // graphPositioner.attr("transform", `translate(${graphWidth / 2},${graphHeight / 2})`)
    // graphRoutes.attr("transform", revTransformValue)
    // console.log('moving graph (' + transformValue + ')')
}, [transformValue])


useEffect(() => {
    hideTooltip()
    currentNode.current = null
    if (graphDepth === 'Carte') {
      max_depth = 2
    }else if (graphDepth == 'POI'){
      max_depth = 3
    } else  if (graphDepth == 'Observation'){
      max_depth = 4
    } else  {
      max_depth = 5
    }
    let width = 50 + 90 * (max_depth -1);
    let height = 50 + 90 * (max_depth -1)
    const radius = width / 2;

    m_Nodes.current = mmNodes
    const stable_nodes = m_Nodes.current

    

    // const stable_disp_matches = r_disp_dom_messages.current
    r_disp_dom_messages.current = disp_dom_messages
    const stab_disp_dom = r_disp_dom_messages.current


    // Sélectionner et configurer le SVG
    const svg = d3s.select(svgRef.current)

async function toggleFullScreenWithTooltip() {
  if (isMobile) {
    try { 
      await document.exitFullscreen()
    } catch (e) {
      console.log('oups')
    }
    return
  }
      const elem = document.getElementById('graphContainer');
    if (!document.fullscreenElement) {
        // Enter full screen

        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { // Firefox
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { // Chrome, Safari and Opera
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { // IE/Edge
            elem.msRequestFullscreen();
        }
    } else {
        // Exit full screen
        setFullScreen(false)
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { // Firefox
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE/Edge
            document.msExitFullscreen();
        }
    }
}


    // Fonction pour basculer en plein écran
  function toggleFullScreen() {
        if( svg.classed('svg_viewbox')){
          svg.classed('svg_viewbox_fullscreen', true)
          svg.classed('svg_viewbox', false)
          const cname = svg.attr('class')
          setSvgClass(cname)
          setFullScreen(false)
        } else {
          setFullScreen(true)
          svg.classed('svg_viewbox', true)
          svg.classed('svg_viewbox_fullscreen', false)
          const cname = svg.attr('class')
          setSvgClass(cname)
        }
    }

// Double-clic pour passer en plein écran
  svg.on('dblclick', toggleFullScreenWithTooltip);      
      

  document.addEventListener('fullscreenchange', (e) => {
    setFullScreen(document.fullscreenElement)
  });

  if (stable_nodes === undefined || stable_nodes.length === 0){
    return
  }
  // Créer un layout en cluster radial
const tree = d3h.tree()
.size([2 * Math.PI, radius]) // Rayon moins une marge

// Appliquer le layout à la hiérarchie
/*
const debug_data = {
  name: "Root",
  children: [
      { name: "Child 1", children: [{ name: "Grandchild 1" }, { name: "Grandchild 2" }] },
      { name: "Child 2", children: [{ name: "Grandchild 3" }, { name: "Grandchild 4" }] },
      { name: "Child 3" }
  ]
};

  const root = d3h.hierarchy(debug_data);
*/
const depths = ['gnu', 'Carte', 'POI',  'Observation', 'Capteurs']
const gdepth = depths.findIndex(d => d === graphDepth) + 1

const reduced_node_set = stable_nodes.filter(d => d.depth <= gdepth)
reduced_node_set.map((d) => {
  if (d.depth == gdepth) {
    d.children = []
  }
})

const hirarch = buildHierarchy(reduced_node_set, gdepth)
if (hirarch === undefined) {
  return
}
const root = d3h.hierarchy(hirarch);
tree(root);

const distance_base_between_nodes = 70

root.each(d => {
 const t = (d.depth / 7) ** 1.15;
 d.y = Math.pow(t, gdepth / 5) * gdepth * distance_base_between_nodes;
});

const links_to_display = root.links()
const nodes_to_display = root.descendants()
//graph.attr('transform', `translate(${graphWidth/2}), ${graphHeight/2}))`);

       // clean first when needed
          // destruction des nodes at exit() pour nettoyer d'abord les affichages avant mis à jour
          svg.select("g[id='graphNodes']").selectAll("circle")
          .data(nodes_to_display).exit().remove();
      
          svg.select("g[id='graphLinks']").selectAll("path")
            .data(links_to_display).exit().remove();
      
          svg.select("g[id='graphLabels']").selectAll("text")
            .data(nodes_to_display).exit().remove();
       
          svg.select("g[id='graphDomNickLabels']").selectAll("text")
                .data(nodes_to_display).exit().remove();
      
          svg.select("g[id='graphDomMessagesBgs']").selectAll("rect")
                .data([]).exit().remove();
      
          svg.select("g[id='graphDomMessagesTexts']").selectAll("text")
                .data([]).exit().remove();

                
function beginsWith(str, prefix) {
    return str.slice(0, prefix.length) === prefix;
}


    // Créer des lignes pour les liens
    const link = svg.select("g[id='graphLinks']").selectAll("path")
      .data(links_to_display)
      .enter().append('path')
      .attr('transform',(d) => {
        const depthOffset = 1 - Math.max(0, gdepth - d.target.depth) / 10
        const ratio = fullScreen ? fullScreenRatio : graphRatio
        return `scale(${ratio}, 1)`
      })
      .attr("d", d3sh.linkRadial()
        .angle(d => {
          return d.x - 3 *  offset_angle
        })
        .radius(d => {
         return d.y
        }))
      .attr('class', (d) => {
        return 'link'
        })

     // Créer des cercles pour les nœuds
    const displayed_nodes = svg.select("g[id='graphNodes']").selectAll("circle")
      .data(nodes_to_display)
      .enter()
      .append('circle')
          .each(function () {
              // stocker le rayon initial une seule fois
              const r = d3.select(this).attr('r');
              d3.select(this).attr('data-r', r);
          })
      .attr('key', (d) => {
        return d.data.id
       })
      .attr('id', (d) => {
        return 'bubble_' + d.data.id
       })
      .attr('r', (d) => compute_node_radius(d))
      .attr("transform", d => {    
            const depthOffset = 1 - Math.max(0, gdepth - d.data.depth) / 10
            const gdepth_adapt = d.data.depth * Math.max(0, 2 + d.data.depth - gdepth )
            const ratio = fullScreen ? fullScreenRatio : graphRatio

            const x = (d.y) * ratio * Math.cos(d.x - offset_angle);
            const y = (d.y) * Math.sin(d.x - offset_angle);
            return `translate(${x},${y}) rotate(0)`;
      })
      .attr('fill', d => {
        if (beginsWith(d.data.id, 'faible')) {
              console.log('debug point')
            }

        if ((d.data.negative === 'true') || (d.data.polarity === 'negative')) {
          return 'red';
        } else {
          return 'lightgreen'
        }
      })
      .attr('opacity', d => {
        let res = bubbles_opacity // d.quality
        if (res === undefined) {
          res = 0.25 // d.data.depth
        }
        if (d.data.depth === 1) {
          return 0.8
        }
        return res
      })
      .attr('class', (d) => {
        let polarity = 'positive'
        if (d.data.polarity) {
          polarity = d.data.polarity
        }           
        if (d.data.negative === 'true') {
          polarity = 'negative'
        }
        return d.data.type + ' ' + polarity

      })
      .on('click', (event, d) => {
        if (event.shiftKey) { 
         if (centerNodeId != null){
           const cn = stable_nodes.find(node => node.id === centerNodeId);
           if (cn){
             cn.fx = null
             cn.fy = null
           }
         }
         setCenterNodeId(d.id);
       } else {
          if (d.data.depth === 1){
            scrollMessages(null)
          }     
       }
      })      
      .on('dblclick', (event, d) => {
        event.stopPropagation();
        request_a_correction(d)
      })
      .on('mouseover', (event, d) => {
       event.stopPropagation();
       try {
       // this computing based on 148 is based on max-width attr of the tooltip div
       // console.log('mouseover ' + d.data.id)
       if (((d.data.description === undefined) || (d.data.description === null))){
        return
       }
       const node = d3s.select(event.target)
       if (currentNode.current && currentNode.current.d.data.id !== d.data.id) return
       if ((d.data.quality < 0.2) && (d.data.depth > 5)){
        return
       }
       cancelHideTooltip()
       cancelShowTooltip()
       currentNode.current = {
          event : event,
          node : node,
          d: d
       };
       // tooltipHovered.current = false
       //const target = event.currentTarget; // ou event.target selon ton contexte
       //target.style.cursor = "help";       
       delayShowToolTip()
      } catch (e) {
        console.log(e)
      }})
     .on('mousemove', (event, d) => {
        if (!currentNode.current || !currentNode.current.displaying) return
        if (!tooltipHovered.current) {
          if (currentNode.current.d !== d) return
          currentNode.current.event = event

          cancelHideTooltip()
          delayHideToolTip()
          if ( ! currentNode.current.displaying) return // initial delay of display
          cancelShowTooltip()
          showTooltip();
        }
        console.log('tooltip move')

        //tooltip.style('left', (event.pageX + 10) + 'px')
        //      .style('top', (event.pageY + 10) + 'px');
      })
     .on('mouseout', (event,d) => {
        event.stopPropagation();
        if (!currentNode.current) return

        if ( event.relatedTarget) { // on est entré dans un autre node
            const target_id = event.relatedTarget.id
            if (target_id !='' && target_id !== d.id){
                return;
            }
        }
        if (currentNode.current.displaying && event.currentTarget.id !== d.id) return

        cancelShowTooltip()
        tooltipHovered.current = false
          // console.log('node out')
          currentNode.current.displaying = false
          hideTooltip()
          // currentNode.current = null;


      })

         /*  test purpose
    const current_dnodes = displayed_nodes.nodes()
    const dnodes_for_retrieval = []
    current_dnodes.forEach(function(dn){dnodes_for_retrieval.push(dn)})

     dnodes.forEach(function(dn, i){
      console.log('node')
     })
*/
        // ajouter les labels
        const labels = svg.select("g[id='graphLabels']").selectAll("text")
        .data(nodes_to_display)
        .enter().append('text')
        .attr('id', d => 'label_' + d.data.id)
        .attr('x', 0)
        .attr('y', d => {
          if (d.data.type === 'domain' && (fullScreen || graphRatio > 1.3)){
            return - 42
          } 
          return 0
        })
        .attr('class', 'dom_label')
        .attr("transform", d => {
          if (d.data.depth === 1){
            return `translate(${graphWidth / 2.2},${graphHeight/ 2.2}) rotate(0)`;
          } 
          const cos = Math.cos(d.x - offset_angle )
          const sin = Math.sin(d.x - offset_angle)
          const sign = cos > 0 ? -1 : 1
          const ratio = fullScreen ? fullScreenRatio : graphRatio

          const x = (d.y + 20 / ratio) * ratio * cos
          const y = (d.y + 20 / ratio) * Math.sin(d.x - offset_angle);
          
          if (d.data.type === 'domain'){
            const index = d.parent.children.indexOf(d)
            return `translate(${x},${y + 25}) rotate(0)`;
          } else if (d.data.type === 'item'){
            return `translate(${x},${y}) rotate(0)`;
          } else {
            const index = d.parent.children.indexOf(d) - ((d.parent.children.length - 1)/ 2)
            //const x = (d.y + 4 + 2 * index)* Math.cos((d.x + index / 1000)- offset_angle);
            //const y = (d.y + 4 + 2 * index) * Math.sin((d.x + index / 1000) - offset_angle);
            return `translate(${x},${y - sign * index * 1.9}) rotate(0)`;
          }
        })
        .attr('class', (d) => 'svg_node_label_' + d.data.depth)
        .attr('pointer-events', 'none')
        .attr("text-anchor", "middle") // Centre le texte horizontalement
        .text(d => {
          return d.data.name
        })

        /*
        .on('mouseover', (event, d) => {
            if (d.data.depth > -1){
                return
            }
            try {
              // this computing based on 148 is based on max-width attr of the tooltip div
              // console.log('mouseover ' + d.data.id)
              // if (((d.data.description === undefined) || (d.data.description === null)) && (d.data.depth > 1)){
              // return
              // }
              // if ((d.data.quality < 0.2) && (d.data.depth > 1)){
              //   return
              // }
              // const n = d3s.select(event.target)
              // const r = n.raise().attr('r', compute_node_radius(d) * 15);

              const desc = d.data.description
              desc.split('--- EXEMPLES ---')[0].split('\n').forEach((substring, index) => {
                const ref =  tooltip_info.current.node()
                if (index === 0){
                  while (ref.nextSibling) {
                    ref.parentNode.removeChild(ref.nextSibling);
                  }
                  ref.textContent = substring
                } else if (substring.length > 0) {
                  const clone = ref.cloneNode(true)
                  ref.parentNode.append(clone)
                  clone.textContent = substring
                }
        
              });
              tooltip.current.on('mousemove', (evt) => {
                tooltip.current
                    .style('left', (event.pageX + 12) + 'px')
                    .style('top', (event.pageY + 12) + 'px');
              }) 
              tooltip.current.style('opacity', 1)
              tooltip.current.style('width', '60%')
              //tooltip.current.style('height', '60%')
              const target = event.currentTarget; // ou event.target selon ton contexte
              //target.style.cursor = "help";       
              tooltip_header.current.text(d.data.name)
            } catch {}
        })
        .on('mousemove', (event, d) => {
            // if (d.data.depth > 3){
            //     return
            // }
            const tooltipWidth = tooltip.current.node().offsetWidth * 0.6;
            const tooltipHeight = tooltip.current.node().offsetHeight;

            // Dimensions de la fenêtre (ou du conteneur, voir plus bas)
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            // Position candidate
            let x = event.pageX + tooltip_margin;
            let y = event.pageY + tooltip_vmargin;

            // Clamp horizontalement
            if (x + tooltipWidth > windowWidth * tooltip_width_threshold) {
              x = event.pageX - tooltipWidth - 5 * tooltip_margin;
            }

            // Clamp verticalement
            if (y + tooltipHeight + tooltip_vmargin > windowHeight * tooltip_width_threshold) {
              y = event.pageY - tooltipHeight - tooltip_vmargin;
            }

            // Appliquer les positions finales
            tooltip.current
              .style('width', '60%')
              .style('left', `${x}px`)
              .style('top', `${y}px`);

            //tooltip.style('left', (event.pageX + 10) + 'px')
            //      .style('top', (event.pageY + 10) + 'px');
          })
        .on('mouseout', (event, d) => {
            if (d.data.depth > 3){
                return
            }
            const ref =  tooltip_info.current[0][0]
            while (ref.nextSibling) {
              ref.parentNode.removeChild(ref.nextSibling);
            }
          tooltip.current.style('opacity', 0);
          tooltip.current.style('width', '0%')

          //const target = event.currentTarget; // ou event.target selon ton contexte
          //target.style.cursor = "auto";       
        })
        .style('pointer-events', (d) => {
          if (gdepth < 4 &&(d.data.type === 'domain' || d.data.type === 'item')){
            return 'auto'
          } else {
            return 'none'
          }
        });
        .style('pointer-events', 'none')
        */



        // NickNames forgotten
        const domain_nick_labels = svg.select("g[id='graphDomNickLabels']").selectAll("text")
        .data(nodes_to_display).enter().append('text')
        .attr('id', d => 'label_nick_' + d.data.id)
        .attr('x', 0)
        .attr('y', 10)
        .attr("transform", d => {
          let offset = 50
          if (gdepth == 3)
            offset = 40
          if (gdepth > 3)
          offset = 40
          const x =  ( d.y + -40)* Math.cos((d.x - offset_angle));
          const y = (d.y - 40) * Math.sin((d.x - offset_angle));
          return `translate(${x},${y}) rotate(0)`;
        })
        .attr("text-anchor", d => d.x < Math.PI ? "start" : "end")
        .attr('class', 'svg_domain_nick_name')
        // .text(d => d.data.nickName)
        .text(d => '')
        .on('dblclick', (event, d) => {
          if (d.data.depth < 2){
            return
          }
        event.stopPropagation();
        request_a_correction(d)
      })
      .style('pointer-events', 'none');

      const filtered_disp_doms = stab_disp_dom.filter((s) => {
        if (s.source == null) return false
        const n = find_source_displayed_nodes(svg, s.source.id)
        return n != null && s.text.length > 0
      })
      let sortedConceptDispDoms = []
      if (filtered_disp_doms) {
        const concept_disp_doms = filtered_disp_doms.filter((s) => s.id.includes('concept'))  
        const sortedConceptDispDomsTemp = concept_disp_doms.sort((a, b) => b.message_id - a.message_id)
        sortedConceptDispDomsTemp.map((s) => {
          sortedConceptDispDoms.push(s.message_id)
        })
      }
      const conceptColorScale = d3sc.scaleLinear()
        // .domain([0, nb_messages]) // index des étapes
        .domain([0, nb_bubbles]) // index des étapes
        .range(["#0ceaf9ff", "#f9e105ff"]);   // début et fin du gradient

      const dom_spans_bgs = svg.select("g[id='graphDomMessagesBgs']").selectAll("rect")
      .data(filtered_disp_doms).enter()
      .append("rect")
      .attr('width', (d) => {
        /*if (d.source.quality !== undefined && d.source.quality < 0.01) 
          return 0*/
        //console.log('width :' + d.id)
        const ratio = fullScreen ? fullScreenRatio : graphRatio

        if (d.id.includes('concept_')) {
          const t = // d.display_index + ' ' + 
                d.text.split(' ').slice(-1)[0]
          return Math.max(10, (t.length + 12 ) * 2)
        } else {
          if (ratio > thresholdForMessages + gdepth / 10) {
            return Math.max(66, d.text.length * 2.12)
          } else {
            return 0
          }
        }
      })
      .on('mouseover', (event, d) => {
       try {
       // this computing based on 148 is based on max-width attr of the tooltip div
       // console.log('mouseover ' + d.id)
        if (! d.id.includes('concept_')) {
          return
        }
        if (currentNode.current && currentNode.current.displaying) return
        console.log('displaying_tooltip: ' + displaying_tooltip.current)
        if (displaying_tooltip.current) return
        // displaying_tooltip.current = true
        const node = d3s.select(event.target)

       currentNode.current = { event,
                              node,
                              d
       }

       showTimeout.current = setTimeout(() => {
                const cn = currentNode.current
                if (cn === null) return   
                displaying_tooltip.current = true

                const event = cn.event
                const node = cn.node
                const d = cn.d
                cn.displaying = true
                let desc = d.path
                const m = disp_dom_messages.find((m) => (m.message_id === d.message_id))
                if (m && m.full_text) {
                  desc = desc + '\n' + m.full_text
                }
                cn['orig-width'] = node.node().getAttribute('width');
                node.attr('width', +node.node().getAttribute('width') * 100);
                cn['orig-height'] = node.node().getAttribute('height');
                currentNode.current = cn
                node.attr('height', +node.node().getAttribute('height') * 100);
                node.attr('opacity',.5);
                const ref =  tooltip_info.current.node()
                desc.split('\n').forEach((substring, index) => {
                  if (index === 0){
                   ref.replaceChildren();
                  }
                  if (substring.length > 0) {
                    const line = document.createElement("p");
                    line.textContent = substring
                    ref.appendChild(line)
                  }
                })
        
                tooltip.current.style('opacity', 1)
                //const target = event.currentTarget; // ou event.target selon ton contexte
                //target.style.cursor = "url('http://localhost:3050/images/eye.svg') 5 5, help;"     
                tooltip_header.current.text('Extracted concept : ' + d.text)
       }, 2 * tooltip_delay)
      } catch {}})
      
     .on('mousemove', (event, d) => {
        event.stopPropagation()
        if (currentNode.current && ! currentNode.current.displaying) return
        if (! d.id.includes('concept_')) {
          return
        }
        const tooltipWidth = tooltip.current.node().offsetWidth * 0.6;
        const tooltipHeight = tooltip.current.node().offsetHeight;

        // Dimensions de la fenêtre (ou du conteneur, voir plus bas)


        // Position candidate
        let x = event.pageX + tooltip_margin;
        let y = event.pageY + tooltip_vmargin;

        // Clamp horizontalement
        if (x + tooltipWidth > windowWidth * tooltip_width_threshold) {
          x = event.pageX - tooltipWidth - 5 * tooltip_margin;
        }

        // Clamp verticalement
        if (y + tooltipHeight + tooltip_vmargin > windowHeight * tooltip_width_threshold) {
          y = event.pageY - tooltipHeight - tooltip_vmargin;
        }

        // Appliquer les positions finales
        console.log('x,y of concept ttip ' + x + ' : ' + y)
        tooltip.current
          .style('width', '40%')
          .style('left', `${x}px`)
          .style('top', `${y}px`);

        //tooltip.style('left', (event.pageX + 10) + 'px')
        //      .style('top', (event.pageY + 10) + 'px');
      })
      
     .on('mouseout', (event, d) => {
        // if (!currentNode.current) return
        if (! d.id.includes('concept_')) {
          return
        }
        
        if ( event.relatedTarget) { // on est entré dans un autre node
            const target_id = event.relatedTarget.id
            if (target_id != d.id && target_id != ''){
                return;
            }
          }
        if (!displaying_tooltip.current) {
          cancelShowTooltip()
          return
        }
        hideTooltip()
        displaying_tooltip.current = false
     })

      .attr('id', d => 'dom_message_bg_' + d.id)
      .attr('height', 4.5)
      .attr('rx', 2)
      .attr('ry', 2)
      .attr('x', d => {
        return -14.5
      }  )
      .attr('y', 8.6)
      .attr("transform", d => {
        // const dnodes = displayed_nodes.nodes()
        const n = find_source_displayed_nodes(svg, d.source.id)
        if (n === null) {
          return `translate(-5000)`;
        }
        const ratio = fullScreen ? fullScreenRatio : graphRatio
        if (d.id.includes('concept_')) {
          const text = //d.display_index + ' ' + 
              d.text.split(' ').slice(-1)[0]
          const cos = Math.cos(n.x - offset_angle )
          const sin = Math.sin(n.x - offset_angle)
          const sign = sin > 0 ? -1 : 1
          const cosign = cos > 0 ? -1 : 1
          let depth_weight = (gdepth + 0.2) + cos * (gdepth)

          const xoffset = cos < 0 ? text.length * depth_weight : 0 
          const x = (n.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
          const y = (n.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.w_idx * sign ;
          return `translate(${x},${y}) rotate(0) scale(${1 + gdepth / 8})`;
          }

        const x =(n.y - 5) * ratio * Math.cos(n.x - offset_angle ) - 26;
        const y = n.y * Math.sin(n.x - offset_angle) - 24 + 3.4 * d.w_idx;
        return `translate(${x},${y}) rotate(0)`;
      })
    //.attr("text-anchor", d => d.x - offset_angle < Math.PI ? "start" : "end")
    .attr('opacity', (d) => {
      return 1
     })      
       .attr('style', d=> {
        const idx = sortedConceptDispDoms.indexOf(d.message_id)
        const color = sortedConceptDispDoms.length >= 1 && idx >= 0 ? conceptColorScale(idx) : sortedConceptDispDoms.length == 0 && idx == 0 ? "0ceaf9ff" :  'whiteSmoke'
        return `fill : ${color};`
       })
 
   .attr('class', (d) => {
      if (d.id.includes('concept_')) {
        if (d.current_target) {
          return 'svg_message_span_bg concept current_target ' + d.polarity
        }
        return 'svg_message_span_bg concept ' + d.polarity
      }  
      if (d.current_target) {
        return 'svg_message_span_bg current_target ' + d.polarity
      } else {
        return 'svg_message_span_bg ' + d.polarity
      }
    })
    .on('dblclick', (event, d) => {
      if (d.id.includes('concept_')) {
        event.stopPropagation();
        request_a_form(d)
      }
   })
   .on('click', (event, d) => {
    scrollMessages(d.message_id)
   });


   const dom_spans =  svg.select("g[id='graphDomMessagesTexts']").selectAll("text")
       // .data(d => d.messages)
       .data(filtered_disp_doms).enter()
       .append("text")
       .text(d => {
        /*if (d.source.quality !== undefined && d.source.quality < 0.01) 
          return ''*/
        const ratio = fullScreen ? fullScreenRatio : graphRatio

        if (d.id.includes('concept_')) {
          const text = // d.display_index + ' ' + 
                d.text.split(' ').slice(-1)
          return text
        }
          if (ratio > thresholdForMessages + gdepth / 10) {
            return d.text
          } else {
            return ''
          }
        })
       // .attr("dy", (d, i) => `${(i) * 0.6}vh`)
       .attr('id', d => 'dom_message_' + d.id)
       .attr('x', d => {
        return 10
        })
       .attr('y', 10)
       .attr("transform", d => {
        // const dnodes = displayed_nodes.nodes()
        const n = find_source_displayed_nodes(svg, d.source.id)
        if (n === null) {
          return `translate(-5000)`;
        }
        const ratio = fullScreen ? fullScreenRatio : graphRatio

        if (d.id.includes('concept_')) {
          const text = // d.display_index + ' ' +  
                d.text.split(' ').slice(-1)
          const cos = Math.cos(n.x - offset_angle )
          const sin = Math.sin(n.x - offset_angle)
          const sign = sin > 0 ? -1 : 1
          // let depth_weight = (gdepth) - cos * (gdepth + 1)
          // if ( gdepth === 2 ) depth_weight = 3 - 3 * cos

          let depth_weight = (gdepth * 0.8)

          // const xoffset = cos < 0 ? text.length * depth_weight : 0 
          // const x = (n.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
          // const y = (n.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.w_idx * sign ;

          const xoffset = cos * Math.max(0.5, text[0].length - 13) * depth_weight / 0.1 

          const cosign = cos > 0 ? 1 : 1
          const x = (n.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
          const y = (n.y + 110 / (gdepth + 1)) * sin - 12.7  + 6 * (1 + gdepth / 7) * d.w_idx * sign;
          //const x = (n.y + 10) * graphRatio * Math.cos(n.x - offset_angle ) - text.length/ 10;
          //const y = n.y * Math.sin(n.x - offset_angle) - 15.85 + 6 * d.w_idx;
          return `translate(${x},${y}) rotate(0) scale(${1 + gdepth / 8})`;
        }
        const x = (n.y -5) * ratio * Math.cos(n.x - offset_angle) + 18  - (45 - d.text.length * 1.4);
        const y = (n.y) * Math.sin(n.x - offset_angle) - 22  + 3.4 * d.w_idx;
        return `translate(${x},${y}) rotate(0)`;
      })
      .attr("text-anchor", d => {
            const n = find_source_displayed_nodes(svg, d.source.id)
            if (n === null) return 'middle'
            const cos  = Math.cos(n.x - offset_angle )
            const sin  = Math.sin(n.x - offset_angle )
            if (d.id.includes('concept_')) {
              const text = //d.display_index + ' ' +  
                    d.text.split(' ').slice(-1)
              if (cos < 1) {
                return text.length <= 10 ? "end" : "middle"
              } else {
                return text.length <= 10 ? "end" : "middle"
              }
            }
            return sin > 1 ? "start" : "end"
            })
            .attr('pointer-events', 'none')
        //.attr("text-anchor", "middle")
        /*
      .on('mouseover', (event, d) => {
       try {
       // this computing based on 148 is based on max-width attr of the tooltip div
       console.log('mouseover ' + d.id)
        if (! d.id.includes('concept_')) {
          return
        }
        let desc = d.path
        const m = disp_dom_messages.find((m) => (m.message_id === d.message_id))
        if (m) {
          desc = desc + '\n' + m.full_text
        }
        desc.split('\n').forEach((substring, index) => {
         const ref =  tooltip_info.current.node()
         if (index === 0){
           while (ref.nextSibling) {
             ref.parentNode.removeChild(ref.nextSibling);
           }
           ref.textContent = substring
         } else if (substring.length > 0) {
           const clone = ref.cloneNode(true)
           ref.parentNode.append(clone)
           clone.textContent = substring
         }
        
       });
       tooltip.current.style('opacity', 1)
       //const target = event.currentTarget; // ou event.target selon ton contexte
       //target.style.cursor = "url('http://localhost:3050/images/eye.svg') 5 5, help;"     
       tooltip_header.current.text('Extracted concept : ' + d.text)
      } catch {}})
     .on('mousemove', (event, d) => {
        if (! d.id.includes('concept_')) {
          return
        }
        const tooltipWidth = tooltip.current.node().offsetWidth * 0.6;
        const tooltipHeight = tooltip.current.node().offsetHeight;

        // Dimensions de la fenêtre (ou du conteneur, voir plus bas)
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;


        // Position candidate
        let x = event.pageX + tooltip_margin;
        let y = event.pageY + tooltip_vmargin;

        // Clamp horizontalement
        if (x + tooltipWidth > windowWidth * tooltip_width_threshold) {
          x = event.pageX - tooltipWidth - 5 * tooltip_margin;
        }

        // Clamp verticalement
        if (y + tooltipHeight + tooltip_vmargin > windowHeight * tooltip_width_threshold) {
          y = event.pageY - tooltipHeight - 10 * tooltip_vmargin;
        }

        // Appliquer les positions finales
        // console.log('x,y of concept ttip ' + x + ' : ' + y)
        tooltip.current
          .style('width', '70%')
          .style('left', `${x}px`)
          .style('top', `${y}px`);

        //tooltip.style('left', (event.pageX + 10) + 'px')
        //      .style('top', (event.pageY + 10) + 'px');
      })
     .on('mouseout', (event, d) => {
        if (! d.id.includes('concept_')) {
          return
        }
        hideTooltip()
     })
        */
   .attr('class', (d) => {
      if (d.id.includes('concept_')) {
        if (d.current_target) {
          return 'svg_dom_message concept current_target ' + d.polarity
        }
        return 'svg_dom_message concept ' + d.polarity
      }  
      if (d.current_target) {
        return 'svg_dom_message current_target ' + d.polarity
      } else {
        return 'svg_dom_message ' + d.polarity
      }
    })

        .on('dblclick', (event, d) => {
              if (d.id.includes('concept_')) {
                event.stopPropagation();
                request_a_form(d)
              }
           })
       .on('click', (event, d) => {
          scrollMessages(d.message_id)
   })  ;

   const routeLinks = []
   let last_concept = null
  if (filtered_disp_doms) {
    const concept_disp_doms = filtered_disp_doms.filter((s) => s.id.includes('concept'))  
    const sortedDispDoms = concept_disp_doms.sort((a, b) => b.message_id - a.message_id)
    setNbBubbles(sortedDispDoms.length)
    for (let i = 0; i < sortedDispDoms.length - 1; i++) {
      if (sortedDispDoms[i].text.trim().length > 0 ) {
        const nn = find_source_displayed_nodes(svg, sortedDispDoms[i].source.id)
        const n = find_source_displayed_texts(svg, sortedDispDoms[i].id)
        if (nn === null || n === null){
          continue
        }

        if (last_concept == null || routeLinks.find((r => r.id === sortedDispDoms[i]))){
          last_concept = i
          continue
        }
        routeLinks.push({
              id : 'go_to_message_' + sortedDispDoms[i].id,
              match_id : sortedDispDoms[i].message_id,
              source: sortedDispDoms[last_concept],
              source_idx : sortedDispDoms[last_concept].w_idx,
              target: sortedDispDoms[i],
              target_idx : sortedDispDoms[i].w_idx
          });
          last_concept = i
        } else {
          continue
        }
      }
    }

   const colorScale = d3sc.scaleLinear()
  .domain([0, routeLinks.length - 1]) // index des étapes
  .range(["#0ceaf9ff", "#f9e105ff"]);   // début et fin du gradient

  const strokeWidthScale = d3sc.scaleLinear()
  .domain([0, routeLinks.length - 1]) // index des étapes
  .range([ 0.3, 0.1]);   // début et fin du gradient

// const routePaths = svg.select("g[id='graphDomMessagesRoute']")
//routePaths.selectAll("path").data([]).exit().remove();
 
  const routeG = svg.select("g[id='graphDomMessagesRoute']")
  routeG.selectAll("g")
                .data([]).exit().remove();
  routeG.selectAll("circle")
                .data([]).exit().remove();
  routeG.selectAll("path")
                .data([]).exit().remove();

  const stage = routeG.selectAll("g")
              .data(routeLinks)
              .enter()
              .append('g').attr('className', 'routeStage')
  
  
  const anchor_decay = (1 + gdepth/6)
  const yratio =  1 +  ((gdepth + 9) / 5)

       
  stage.append("circle")
              .attr('className', 'path anchor source')
              .attr('cx', (d) => {
                const n1 = find_source_displayed_nodes(svg, d.source.source.id)
                if (n1 === null) {
                        return `translate(-5000)`;
                }
                const text = // d.source.display_index + ' ' + 
                    d.source.text.split(' ').slice(-1)[0]
                const cos = Math.cos(n1.x - offset_angle )
                const sin = Math.sin(n1.x - offset_angle)
                let depth_weight = (gdepth + 0.2) + cos * (gdepth)
                const sign = sin > 0 ? -1 : 1
                const ratio = fullScreen ? fullScreenRatio : graphRatio

                const xoffset = cos < 0 ? text.length * depth_weight : 0 
                const x = (n1.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
                const y = (n1.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.source.w_idx * sign ;
                const x1 = x + 5 
                return x1
              })

              .attr('cy', (d) => {
                const n1 = find_source_displayed_nodes(svg, d.source.source.id)
                if (n1 === null) {
                        return `translate(-5000)`;
                }
                const text = // d.source.display_index + ' ' + 
                        d.source.text.split(' ').slice(-1)[0]
                const cos = Math.cos(n1.x - offset_angle )
                const sin = Math.sin(n1.x - offset_angle)
                let depth_weight = (gdepth + 0.2) + cos * (gdepth)
                const sign = sin > 0 ? -1 : 1
                const ratio = fullScreen ? fullScreenRatio : graphRatio

                const xoffset = cos < 0 ? text.length * depth_weight : 0 
                const y = (n1.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.source.w_idx * sign ;
                const y1 = y + 3.7 * yratio
                return y1
              })
              .attr('r', 2 * gdepth / 6 )
              .attr("stroke", (d,i) => colorScale(i))
   stage.append("circle")
              .attr('className', 'path anchor source center')
              .attr('cx', (d) => {
                const n1 = find_source_displayed_nodes(svg, d.source.source.id)
                if (n1 === null) {
                        return `translate(-5000)`;
                }
                const text = // d.source.display_index + ' ' + 
                      d.source.text.split(' ').slice(-1)[0]
                const cos = Math.cos(n1.x - offset_angle )
                const sin = Math.sin(n1.x - offset_angle)
                let depth_weight = (gdepth + 0.2) + cos * (gdepth)
                const sign = sin > 0 ? -1 : 1
                const ratio = fullScreen ? fullScreenRatio : graphRatio

                const xoffset = cos < 0 ? text.length * depth_weight : 0 
                const x = (n1.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
                const y = (n1.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.source.w_idx * sign ;
                const x1 = x + 5 
                return x1
           })
              .attr('cy', (d) => {
                const n1 = find_source_displayed_nodes(svg, d.source.source.id)
                if (n1 === null) {
                        return `translate(-5000)`;
                }
                const text = // d.source.display_index + ' ' + 
                      d.source.text.split(' ').slice(-1)[0]
                const cos = Math.cos(n1.x - offset_angle )
                const sin = Math.sin(n1.x - offset_angle)
                let depth_weight = (gdepth + 0.2) + cos * (gdepth)
                const sign = sin > 0 ? -1 : 1
                const ratio = fullScreen ? fullScreenRatio : graphRatio

                const xoffset = cos < 0 ? text.length * depth_weight : 0 
                const x = (n1.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
                const y = (n1.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.source.w_idx * sign ;
                const y1 = y + 3.7 * yratio
                return y1
              })
              .attr('r', 0.9)
              .attr('fill', 'none')
              .attr('stroke', 'black')
              .attr('stroke-width', 0.3)

  stage.append("circle")
              .attr('className', 'path anchor target')
              .attr('cx', (d) => {
                const n1 = find_source_displayed_nodes(svg, d.target.source.id)
                if (n1 === null) {
                        return `translate(-5000)`;
                }
                const text = // d.target.display_index + ' ' + 
                      d.target.text.split(' ').slice(-1)[0]
                const cos = Math.cos(n1.x - offset_angle )
                const sin = Math.sin(n1.x - offset_angle)
                let depth_weight = (gdepth + 0.2) + cos * (gdepth)
                const sign = sin > 0 ? -1 : 1
                const ratio = fullScreen ? fullScreenRatio : graphRatio

                const xoffset = cos < 0 ? text.length * depth_weight : 0 
                const x = (n1.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
                const y = (n1.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.target.w_idx * sign ;
                const x1 = x + text.length * 2 
                return x1
              })
              .attr('cy', (d) => {
                const n1 = find_source_displayed_nodes(svg, d.target.source.id)
                if (n1 === null) {
                        return `translate(-5000)`;
                }
                const text = // d.target.display_index + ' ' + 
                    d.target.text.split(' ').slice(-1)[0]
                const cos = Math.cos(n1.x - offset_angle )
                const sin = Math.sin(n1.x - offset_angle)
                let depth_weight = (gdepth + 0.2) + cos * (gdepth)
                const sign = sin > 0 ? -1 : 1
                const ratio = fullScreen ? fullScreenRatio : graphRatio

                const xoffset = cos < 0 ? text.length * depth_weight : 0 
                const x = (n1.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
                const y = (n1.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.target.w_idx * sign ;
                const y1 = y + 5.2 * yratio 
                return y1
              })
              .attr('r', 2 * gdepth/6)
              .attr("stroke", (d,i) => colorScale(i))
   stage.append("circle")
              .attr('className', 'path anchor target center')
              .attr('cx', (d) => {
                const n1 = find_source_displayed_nodes(svg, d.target.source.id)
                if (n1 === null) {
                        return `translate(-5000)`;
                }
                const text = // d.target.display_index + ' ' + 
                      d.target.text.split(' ').slice(-1)[0]
                const cos = Math.cos(n1.x - offset_angle )
                const sin = Math.sin(n1.x - offset_angle)
                let depth_weight = (gdepth + 0.2) + cos * (gdepth)
                const sign = sin > 0 ? -1 : 1
                const ratio = fullScreen ? fullScreenRatio : graphRatio

                const xoffset = cos < 0 ? text.length * depth_weight : 0 
                const x = (n1.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
                const y = (n1.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.target.w_idx * sign ;
                const x1 = x + text.length * 2
                return x1
              })
              .attr('cy', (d) => {
                const n1 = find_source_displayed_nodes(svg, d.target.source.id)
                if (n1 === null) {
                        return `translate(-5000)`;
                }
                const text = // d.target.display_index + ' ' + 
                      d.target.text.split(' ').slice(-1)[0]
                const cos = Math.cos(n1.x - offset_angle )
                const sin = Math.sin(n1.x - offset_angle)
                let depth_weight = (gdepth + 0.2) + cos * (gdepth)
                const sign = sin > 0 ? -1 : 1
                const ratio = fullScreen ? fullScreenRatio : graphRatio

                const xoffset = cos < 0 ? text.length * depth_weight : 0 
                const x = (n1.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
                const y = (n1.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.target.w_idx * sign ;
                const y1 = y + 5.2 * yratio
                return y1
              })
              .attr('r', 1 * gdepth/6)
              .attr("stroke", (d,i) => colorScale(i))
  stage.append("path")
              .attr("class", d => {
                return "route " + d.source.id
              })
              .attr("d", (d) => {
                const n1 = find_source_displayed_nodes(svg, d.target.source.id)
                let text = // d.target.display_index + ' ' + 
                      d.target.text.split(' ').slice(-1)[0]
                const ratio = fullScreen ? fullScreenRatio : graphRatio
                const cos = Math.cos(n1.x - offset_angle )
                const sin = Math.sin(n1.x - offset_angle)
                const sign = sin > 0 ? -1 : 1
                let depth_weight = (gdepth + 0.2) + cos * (gdepth)
                let xoffset = cos < 0 ? text.length * depth_weight : 0 
                let x = (n1.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos;
                let y = (n1.y + 110 / (gdepth + 1)) * sin - 16  + 6 * (1 + gdepth / 7) * d.target.w_idx * sign ;
                const x1 = x + text.length * 2
                const y1 = y + 5.2 * yratio
                const n2 = find_source_displayed_nodes(svg, d.source.source.id)
                const cos2 = Math.cos(n2.x - offset_angle )
                const sin2 = Math.sin(n2.x - offset_angle)
                const sign2 = sin2 > 0 ? -1 : 1
                text = // d.source.display_index + ' ' + 
                      d.source.text.split(' ').slice(-1)[0]
                depth_weight = (gdepth + 0.2) + cos2 * (gdepth)
                xoffset = cos2 < 0 ? text.length * depth_weight : 0 
                x = (n2.y + (100 + xoffset) / (gdepth + 1)) * ratio * cos2;
                y = (n2.y + 110 / (gdepth + 1)) * sin2 - 16  + 6 * (1 + gdepth / 7) * d.source.w_idx * sign2 ;
                const x2 = x + 5
                const y2 = y + 3.4 * yratio
                  // arc Bézier
                  const dx = x2 - x1;
                  const dy = y2 - y1;
                  const c = 0.5;

                  const cx = (x1 + x2) / 2 - dy * c;
                  const cy = (y1 + y2) / 2 + dx * c;
                  return "M " + x1 + " " + y1 + 
                  " Q " + cx + " " + cy + 
                   " " + x2 + " " + y2
                 const dp = [`M ${x1} ${y1}`,
                 `C ${x1}, ${cx} ${cy}, ${x2} ${y2}`].join(' ')
                 return dp
              })

              .attr("fill", "none")
              .attr("stroke", (d,i) => colorScale(i))
              .attr("stroke-width", (d,i) => strokeWidthScale(i) * (gdepth))
              .attr("stroke-dasharray", "2 1")
              .attr("marker-end", "url(#arrow)");
    // update colors of bubbles
    const cnodes = svg.select("g[id='graphNodes']").selectAll("circle")
    cnodes.attr("opacity", function(d) { 
      let res = bubbles_opacity // d.data.quality
      if (res === undefined) {
        res = 0.25
      }
      if (d.data.depth === 1) {
        return 0.8
      }
      return (res ** 2) * 5; 
    }).attr('class', d => {
      let polarity = 'positive'
      if (d.data.polarity) {
          polarity = d.data.polarity
      }           
      if (d.data.negative === 'true') {
          polarity = 'negative'
      }
      return d.data.type + ' ' + polarity
    }).attr('r' , (d) => compute_node_radius(d))

  setTimeout(() => {
      svg.call(fzoom);
  }, 0)

  }, [mmNodes, domain_matches, disp_dom_messages, graphRatio, graphDepth, 
      svgClass, fullScreen]);
          
          
  return (
    <div  className={window.innerWidth < 400 ? 'graphContainer mobile' : 'graphContainer'} id='graphContainer' >
      <svg ref={svgRef} style={{ border: '0px solid black' }}>
       <g id='graphPositioner'>
         <rect width='87%' height= '100%' className='graph-background'/>
        <g id='graph'>
         <g id='graphLinks' stroke='#666' strokeWidth='1.5'></g>
         <g id='graphNodes' stroke='#fff' strokeWidth='1.5'></g>
         <g id='graphLabels' stroke='#222' strokeWidth='1.5'></g>
         <g id='graphDomNickLabels' stroke='#222' strokeWidth='1.5'></g>
         <g id='graphDomMessages' stroke='#222' strokeWidth='1.5'>
         <g id='graphDomMessagesBgs' stroke='#222' strokeWidth='1.5'/>
          <g id='graphDomMessagesRoute'/>
        <g id='graphDomMessagesTexts' stroke='#222' strokeWidth='1.5'/>
         </g>
        </g>
       </g>
      </svg>

     </div>
  );

}



export default RadialGraph;